import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Referência formatada: link da OP + apontamento em texto menor.
 */
export function ProductionOrderDocumentRef({ productionOrderId, reportId }) {
    if (productionOrderId == null) {
        return null;
    }

    return (
        <span className="inline-flex min-w-0 flex-col gap-0.5">
            <Link
                to={`/production/orders/${productionOrderId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-800 hover:underline font-medium leading-snug"
            >
                {`Ordem de Produção #${productionOrderId}`}
            </Link>
            {reportId != null && (
                <span className="text-xs text-gray-600 leading-snug">{`Apontamento #${reportId}`}</span>
            )}
        </span>
    );
}

export default ProductionOrderDocumentRef;
